import React from 'react';
import PropTypes from 'prop-types';
import s from './SponsoredBy.scss';

const SponsorLogo = props => {
  const { sponsorLead, sponsorLogoUrl, sponsorCtaUrl, cssClass } = props;
  return (
    <>
      <div className={`${s.sponsorContainer} ${cssClass}`}>
        {sponsorLead && sponsorLogoUrl && <i />}
        {sponsorLead && <span>{sponsorLead}</span>}
        {sponsorLead && sponsorLogoUrl && <i />}
        {sponsorLogoUrl &&
          sponsorCtaUrl && (
            <a
              href={sponsorCtaUrl}
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              <img alt="" src={sponsorLogoUrl} />
            </a>
          )}
        {sponsorLogoUrl &&
          !sponsorCtaUrl && <img alt="" src={sponsorLogoUrl} />}
      </div>
    </>
  );
};

SponsorLogo.propTypes = {
  sponsorLead: PropTypes.string,
  sponsorLogoUrl: PropTypes.string,
  sponsorCtaUrl: PropTypes.string,
};

SponsorLogo.defaultProps = {
  sponsorLead: null,
  sponsorLogoUrl: null,
  sponsorCtaUrl: null,
};

export default SponsorLogo;
